import { Separator } from "@/components/ui/separator";
import {
  Linkedin,
  Instagram,
  Facebook,
} from "lucide-react";
import Image from "next/image";
import Link from "next/link";
const footerLinks = [
  {
    title: "Blog",
    href: "/blog",
  },
  {
    title: "Privacy",
    href: "/privacy",
  },
  {
    title: "T&C",
    href: "/terms",
  },
  {
    title: "Refunds",
    href: "/refund",
  },
  {
    title: "Shipping",
    href: "/shipping",
  },
  {
    title: "Contact",
    href: "/contact",
  },
];

const Footer05Page = () => {
  return (
    <div className="flex flex-col">
      <div className="bg-muted" />
      <footer className="border-t">
        <div className="max-w-(--breakpoint-xl) mx-auto">
          <div className="py-12 flex flex-col justify-start items-center">
            {/* Logo */}
            <img alt="Assignowl Logo" src={'/comman/logo.svg'} className="w-24" />
            <ul className="mt-6 flex items-center gap-4 flex-wrap">
              {footerLinks.map(({ title, href }) => (
                <li key={title}>
                  <Link
                    href={href}
                    className="text-muted-foreground hover:text-foreground"
                  >
                    {title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <Separator />
          <div className="py-8 flex flex-col-reverse sm:flex-row items-center justify-between gap-x-2 gap-y-5 px-6 xl:px-0">
            {/* Copyright */}
            <span className="text-muted-foreground">
              &copy; {new Date().getFullYear()}{" "}
              <Link href="/" target="_blank">
                Assignowl
              </Link>
              . All rights reserved.
            </span>

            <div className="flex items-center gap-5 text-muted-foreground">
              <Link href="https://www.linkedin.com/company/assignowl" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <Linkedin className="h-5 w-5 hover:text-foreground transition-colors" />
              </Link>
              <Link href="https://www.instagram.com/assignowl" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <Instagram className="h-5 w-5 hover:text-foreground transition-colors" />
              </Link>
              <Link href="https://www.facebook.com/assignowl" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <Facebook className="h-5 w-5 hover:text-foreground transition-colors" />
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer05Page;
